import React, { useEffect, useState } from "react";

import { Image } from "Components/atoms/Image";
import { Typography } from "Components/atoms/Typography";
import { useBreakpoint } from "shared/hooks/useBreakpoint";

import { InfoFlight, InfoSegment, SegmentContainer } from "./styles";
import { FlightSegmentProps } from "./types";

export const FlightCardDetailsSegment: React.FC<FlightSegmentProps> = ({
  departureAirportDescription,
  arrivalAirportDescription,
  flightNumber,
  departureTime,
  departureAirport,
  arrivalTime,
  arrivalAirport,
  duration,
  airlineName,
}) => {
  const [desktop, setDesktop] = useState(false);
  const breakpoint = useBreakpoint();

  useEffect(() => {
    setDesktop(
      breakpoint === "xxl" || breakpoint === "xl" || breakpoint === "lg",
    );
  }, [breakpoint]);

  return (
    <SegmentContainer>
      <InfoFlight>
        <Image
          src={`https://voopter.com.br/voopter-static-assets/airline-logos/${airlineName}.png`}
          alt={airlineName}
          height={!desktop ? "1rem" : "2rem"}
        />
        <Typography variant="label" color="mediumGray">
          Voo nº <strong>{flightNumber}</strong>
        </Typography>
      </InfoFlight>

      <InfoSegment>
        <Typography variant="caption" color="mediumGray">
          <strong>
            {departureTime} {departureAirport}
          </strong>{" "}
          - {departureAirportDescription}
        </Typography>
        <Typography variant="caption" color="darkGray" weight="extraLight">
          Duração do voo: {duration}
        </Typography>
        <Typography variant="caption" color="mediumGray">
          <strong>
            {arrivalTime} {arrivalAirport}
          </strong>{" "}
          - {arrivalAirportDescription}
        </Typography>
      </InfoSegment>
    </SegmentContainer>
  );
};
